import { ParamTypeException } from "../exception/Exception";
export function assertString(input, sign) {
    if (sign === void 0) { sign = "Input"; }
    if (typeof input === "string")
        return;
    else
        throw new ParamTypeException("[" + sign + "] should be a string!");
}
export function assertFunction(input, sign) {
    if (sign === void 0) { sign = "Input"; }
    if (typeof input === "function")
        return;
    else
        throw new ParamTypeException("[" + sign + "] should be a function!");
}
export function assertNumber(input, sign) {
    if (sign === void 0) { sign = "Input"; }
    if (typeof input === "number")
        return;
    else
        throw new ParamTypeException("[" + sign + "] should be a number!");
}
